import { render, staticRenderFns } from "./Publicacion.vue?vue&type=template&id=0e60a792&scoped=true"
import script from "./Publicacion.vue?vue&type=script&lang=js"
export * from "./Publicacion.vue?vue&type=script&lang=js"
import style0 from "./Publicacion.vue?vue&type=style&index=0&id=0e60a792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60a792",
  null
  
)

export default component.exports